import CustomComponent from '../CustomComponent';

export const SNACKBAR_DISMISS_EVENT = 'snackbar-dismiss';

export const escapeHtml = (value = '') =>
	String(value)
		.replaceAll('&', '&amp;')
		.replaceAll('<', '&lt;')
		.replaceAll('>', '&gt;')
		.replaceAll('"', '&quot;')
		.replaceAll("'", '&#39;');

export class SnackbarComponent extends CustomComponent {
	static key = 'lta-snackbar';

	static get observedAttributes() {
		return ['message', 'button-label', 'classes', 'icon', 'type', 'hidden', 'label-classes', 'button-class'];
	}

	constructor() {
		super();
		this.handleDismiss = this.handleDismiss.bind(this);
	}

	get isHidden() {
		const hiddenAttr = this.getAttribute('hidden');
		return hiddenAttr !== null && hiddenAttr !== 'false';
	}

	get defaultType() {
		return 'success';
	}

	get defaultIcon() {
		return '';
	}

	get defaultButtonLabel() {
		return '';
	}

	get defaultLabelClasses() {
		return 'title';
	}

	get defaultButtonClass() {
		return '';
	}

	get dismissEventName() {
		return SNACKBAR_DISMISS_EVENT;
	}

	show(message) {
		if (typeof message === 'string') {
			this.setAttribute('message', message);
		}
		this.removeAttribute('hidden');
	}

	hide() {
		this.setAttribute('hidden', '');
	}

	handleDismiss() {
		this.hide();
		this.dispatchEvent(
			new CustomEvent(this.dismissEventName, {
				bubbles: true,
				composed: true,
				detail: {
					message: this.getAttribute('message') || ''
				}
			})
		);
	}

	render() {
		const {
			message = '',
			buttonLabel = this.defaultButtonLabel,
			classes = '',
			icon = this.defaultIcon,
			type = this.defaultType,
			labelClasses = this.defaultLabelClasses,
			buttonClass = this.defaultButtonClass
		} = this.props;

		const resolvedIcon = icon || this.defaultIcon;
		const resolvedButtonLabel = buttonLabel || this.defaultButtonLabel;
		const resolvedLabelClasses = labelClasses || this.defaultLabelClasses;
		const resolvedButtonClass = buttonClass || this.defaultButtonClass;

		const classNames = [
			'lta-snackbar',
			`lta-snackbar--${type || this.defaultType}`,
			resolvedIcon ? 'has-icon' : '',
			'u-vstack',
			this.isHidden ? 'u-hidden' : '',
			classes
		]
			.filter(Boolean)
			.join(' ');

		const safeMessage = escapeHtml(message);
		const safeButtonLabel = escapeHtml(resolvedButtonLabel);
		const labelClassNames = ['lta-snackbar__label', resolvedLabelClasses].filter(Boolean).join(' ');
		const buttonClassNames = [
			'lta-btn',
			'lta-btn--sm',
			'lta-btn--inverse',
			'lta-btn--block',
			'u-ml-1',
			resolvedButtonClass
		]
			.filter(Boolean)
			.join(' ');

		return `
			<div class="${classNames}" role="alert">
				<p class="${labelClassNames}" aria-label="${safeMessage}">${safeMessage}</p>
				${
					resolvedButtonLabel
						? `<button
					type="button"
					class="${buttonClassNames}"
					data-snackbar-dismiss
					aria-label="${safeButtonLabel}"
				>
					${safeButtonLabel}
				</button>`
						: ''
				}
				${
					resolvedIcon
						? `<div class="lta-snackbar__icon">
					<svg class="lta-icon" width="1em" height="1em" fill="currentColor" aria-hidden="true" role="img">
						<use xlink:href="/static/images/icons/lta-icons.svg#${escapeHtml(resolvedIcon)}"></use>
					</svg>
				</div>`
						: ''
				}
			</div>
		`;
	}

	afterRender() {
		this.querySelector('[data-snackbar-dismiss]')?.addEventListener('click', this.handleDismiss);
	}

	onUnload() {
		this.querySelector('[data-snackbar-dismiss]')?.removeEventListener('click', this.handleDismiss);
	}
}

export default SnackbarComponent;
